import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';


let expected_row = [
    {fact: "Research Date", content: "March to May 2023"},
    {fact: "Moderator", content: "Nic P., Olivia S."},
    {fact: "Participants", content: "5 MEC Staffers"},
    {fact: "Research Method", content: "Qualitative Moderate"},
    {fact:"Incentive",content:"$50 MEC Gift Card"}
]

function BasicTable() {
    return (
        <TableContainer component={Paper}>
            <Table sx={{minWidth: 650}} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>MEC Research</TableCell>
                        <TableCell align="left">Content</TableCell>
                        {/*<TableCell align="right">Fat&nbsp;(g)</TableCell>*/}
                        {/*<TableCell align="right">Carbs&nbsp;(g)</TableCell>*/}
                        {/*<TableCell align="right">Protein&nbsp;(g)</TableCell>*/}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {expected_row.map((row) => (
                        <TableRow
                            key={row.fact}
                            sx={{'&:last-child td, &:last-child th': {border: 0}}}
                        >
                            <TableCell component="th" scope="row">
                                {row.fact}
                            </TableCell>
                            <TableCell align="left">{row.content}</TableCell>
                            {/*<TableCell align="right">{row.fat}</TableCell>*/}
                            {/*<TableCell align="right">{row.carbs}</TableCell>*/}
                            {/*<TableCell align="right">{row.protein}</TableCell>*/}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default BasicTable
